(function () {
  // Bryce 2026-05-05: persist last-shown slide per section across
  // theme-editor reloads. When a block setting changes, Shopify
  // unmounts and remounts the section; the IIFE re-runs and init
  // sees current=0. Stash the current index on a window-level cache
  // keyed by Shopify section id so the new init can pick it back up.
  // Outside the IIFE-instance scope so it survives the remount.
  window.__vHeroLastIndex = window.__vHeroLastIndex || {};

  function inEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function init(root) {
    if (root.__vHeroInit) return;
    root.__vHeroInit = true;

    const track = root.querySelector('[data-v-hero-track]');
    const slides = root.querySelectorAll('.v-hero__slide');
    const dots = root.querySelectorAll('.v-hero__dot');
    const prevBtn = root.querySelector('[data-v-hero-prev]');
    const nextBtn = root.querySelector('[data-v-hero-next]');
    const total = slides.length;
    if (total <= 1) return;

    // Resolve the Shopify section id for this slider so we can save
    // and restore the active slide across editor remounts.
    const sectionEl = root.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl ? sectionEl.id : '';

    const transType = root.dataset.transitionType || 'slide';
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.autoplayInterval, 10) || 6000;
    const pauseOnHover = root.dataset.pauseOnHover === 'true';
    const swipeEnabled = root.dataset.enableSwipe === 'true';

    let current = 0;
    let timer = null;
    // Editor sticky-slide flag: once a block is selected in the
    // theme editor, lock the slider to that slide and ignore any
    // would-be auto-advances until the user clears selection.
    let editorLocked = false;

    function render(idx) {
      current = ((idx % total) + total) % total;
      if (transType === 'slide') {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
      } else {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      }
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      if (sectionId) window.__vHeroLastIndex[sectionId] = current;
    }

    // Restore last-shown slide if this section was just remounted
    // by the editor. Falls through to 0 when nothing is cached.
    let startIndex = 0;
    if (sectionId && Object.prototype.hasOwnProperty.call(window.__vHeroLastIndex, sectionId)) {
      const cached = window.__vHeroLastIndex[sectionId];
      if (typeof cached === 'number' && cached >= 0 && cached < total) {
        startIndex = cached;
      }
    }

    if (transType === 'fade') {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === startIndex); });
    } else if (startIndex > 0) {
      // Slide mode: position the track without animating to avoid a
      // flash from slide 0 on first paint after a settings change.
      const prevTransition = track.style.transition;
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (startIndex * 100) + '%)';
      // Force layout and restore the transition for subsequent moves.
      void track.offsetWidth;
      track.style.transition = prevTransition;
    }
    current = startIndex;
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });

    function next() { render(current + 1); }
    function prev() { render(current - 1); }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var t = parseInt(d.dataset.slideTarget, 10);
        if (!isNaN(t)) { render(t); restart(); }
      });
    });

    function start() {
      if (!autoplay) return;
      // In the theme editor, autoplay would constantly yank the
      // merchant off the slide they're editing. Hard-disable it.
      if (inEditor()) return;
      // Once a block is selected, stay put until the user clears
      // selection (handled by shopify:block:deselect below).
      if (editorLocked) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (autoplay && pauseOnHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    if (swipeEnabled) {
      var startX = 0, dx = 0, dragging = false;
      root.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        dx = 0;
        dragging = true;
        stop();
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dx = e.touches[0].clientX - startX;
      }, { passive: true });
      root.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(dx) > 50) {
          if (dx < 0) next(); else prev();
        }
        start();
      });
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(root)) {
        root.__vHeroInit = false;
        init(root);
      }
    });

    // ────────────────────────────────────────────────────────────
    // Theme-editor stickiness (Bryce 2026-05-05)
    //
    // Without this, every settings change on a non-first slide's
    // block remounts the section and resets the slider to slide 0.
    // The merchant has to manually re-navigate after every keystroke.
    //
    // Shopify fires shopify:block:select right after a remount with
    // event.target == the just-selected block element. We walk up
    // to the nearest .v-hero__slide, read its data-slide-index, and
    // jump there. editorLocked then suppresses any autoplay tick
    // until the editor deselects.
    //
    // Slide-divider blocks are themselves .v-hero__slide elements,
    // so the closest() walk handles those too.
    // ────────────────────────────────────────────────────────────
    function findSlideIndex(el) {
      if (!el || !el.closest) return -1;
      const slide = el.closest('.v-hero__slide');
      if (!slide || !root.contains(slide)) return -1;
      const v = parseInt(slide.dataset.slideIndex, 10);
      return isNaN(v) ? -1 : v;
    }

    document.addEventListener('shopify:block:select', function (e) {
      const idx = findSlideIndex(e.target);
      if (idx < 0) return;
      editorLocked = true;
      stop();
      render(idx);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      // Only release the lock if the deselected block belongs to
      // this slider — other sections' deselect events shouldn't
      // affect us.
      if (!root.contains(e.target)) return;
      editorLocked = false;
      // Don't auto-resume in the editor; the merchant can scrub
      // manually with arrows or dots while still editing.
    });

    document.addEventListener('shopify:section:select', function (e) {
      // When the merchant clicks the section header in the sidebar,
      // pause autoplay so the slider stops moving while they pick
      // a block to edit.
      if (e.target && (e.target.contains(root) || root.contains(e.target))) {
        stop();
      }
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && (e.target.contains(root) || root.contains(e.target))) {
        editorLocked = false;
      }
    });

    start();
  }

  function bootAll() {
    document.querySelectorAll('[data-v-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
